import React from 'react';
import {Document, Font} from '@react-pdf/renderer';
import font from 'assets/SofiaPro-Regular.otf';
import fontBold from 'assets/SofiaPro-Bold.otf';
import {CoverPage} from './pages/cover';
import {UtilizationPage} from './pages/utilization';
import { EnvironmentalEffectsPage } from './pages/environmentalEffects';
import { MaintenancePage } from './pages/maintenance';
import { getCoverImageForRecommendedSleipner } from 'utils/images';

Font.register({
	family: 'SofiaPro',
	fonts: [
		{
			src: font,
		},
		{
			src: fontBold,
			fontWeight: 600,
		},
	],
});
const hyphenationCallback = (word) => {
	return [word];
};
// prevent hyphenation
Font.registerHyphenationCallback(hyphenationCallback);

// Create Document Component
const Pdf = ({formValues, calculatedValues, recommendedSleipner, showellUser, customer, charts}) => {

	const sleipnerCoverImage = getCoverImageForRecommendedSleipner(recommendedSleipner.model);

	const pageProps = {
		customer,
		showellUser,
		recommendedSleipner: {...recommendedSleipner, coverImageUrl: sleipnerCoverImage},
		calculatedValues,
		formValues,
		charts
	}

	// console.log(pageProps);

	return (
		<Document>
			<CoverPage {...pageProps}></CoverPage>
			<UtilizationPage {...pageProps}></UtilizationPage>
			<EnvironmentalEffectsPage {...pageProps}></EnvironmentalEffectsPage>
			<MaintenancePage {...pageProps}></MaintenancePage>
		</Document>
	);
};

export default Pdf;
